import type { FinancialFieldMetaData, FieldMetaData } from "./fieldsMetaData";

const createFieldMetaData = (
    isEmpty: boolean,
    hidden: boolean,
    editDisabled: boolean,
): FieldMetaData => ({
    // isEmpty,
    // hidden,
    // editDisabled,
    fields: () => ({ isEmpty, hidden, editDisabled }),
});

const createFinancialFieldMetaData = (
    label: string,
    labelTitle: string,
    sublabel: string,
    isEmpty: boolean,
    hidden: boolean,
    editDisabled: boolean,
): FinancialFieldMetaData => ({
    // label,
    // labelTitle,
    // sublabel,
    // isEmpty,
    // hidden,
    // editDisabled,
    fields: () => ({ label, labelTitle, sublabel, isEmpty, hidden, editDisabled }),
});

export { createFieldMetaData, createFinancialFieldMetaData };